<template>
    <Popup
            v-model="popupShow"
            closeable
            position="bottom"
            radius="5px"
            class="select-action-popup"
    >
        <div class="popup-bar">
            <!--<div class="cancel" @click="onCancel">取消</div>-->
            <div class="title"> 请选择操作</div>
            <!--<div class="ok" @click="onOk">确定</div>-->
        </div>
        <div class="content">
            <Collapse v-model="activeAction" accordion>
                <CollapseItem v-for="action in actionList" :title="action.name" :name="action.code" :key="action.id">
                    <ControlAction :action="action" :deviceId="deviceId" @submit="onSubmit"
                                   :defaultValue="actionValue"/>
                </CollapseItem>
            </Collapse>
        </div>
    </Popup>
</template>

<script>
    import {Collapse, CollapseItem, Popup,} from "vant"
    import {downloadImg} from "@/config"
    import ControlAction from "../ControlAction"

    export default {
        components: {
            Popup,
            Collapse, CollapseItem,
            ControlAction
        },
        props: {
            show: {type: Boolean, default: false},
            deviceId: {type: String, default: ''},
            selectAction: {type: String, default: ''},
            defaultValue: {type: Object, default: {}},
            actionList: {type: Array, required: true},
        },
        data() {
            return {
                activeAction: '',
            }
        },
        computed: {
            popupShow: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
            actionValue() {
                return this.defaultValue
            }
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            // onOk() {
            //     this.$emit('ok', this.selected)
            // },
            onSubmit(action, param) {
                this.$emit('ok', action, param)
            }

        },
        watch: {
            selectAction(selectAction) {
                this.activeAction = selectAction
            },
        }
    };
</script>
<style lang="less" scoped>
    .select-action-popup {
        height: calc(100% - 140px);
        & > .content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 52px);
            overflow-y: auto;
        }
    }

    .action-item {

        &.selected {
            border: 1px solid rgba(24, 144, 255, 1);
        }
        padding: 5px;
        display: flex;
        border-radius: 5px;
        border: 1px solid rgba(111, 111, 111, 0.3);
        margin-top: 2px;
        margin-bottom: 5px;
        & > img {
            height: 50px;
            width: 50px;
        }
        & > .right {
            margin-left: 8px;
            line-height: 1.5;
            & > .device-name {
                font-weight: 500;
                font-size: 18px;
            }
            & > .product-name {
                color: #999;
                font-size: 15px;
            }
        }
    }
</style>
